import React from "react";
import images from "../../../images";

const TimelineCommon = ({ steps }) => {
  return (
    <ul className="m-4 max-w-screen-md ">
      {steps.map((step, index) => (
        <li key={index} className="relative pl-7 pb-8 last:pb-0">
          {/* Line connector */}
          {index !== steps.length - 1 && (
            <div className="absolute left-2 top-0 bottom-0 w-0.5 bg-[#08B89D]"></div>
          )}

          {/* Step Icon */}
          <div
            className={`absolute left-0 flex h-4 w-4 items-center justify-center rounded-full text-sm font-bold ${
              step.completed ? "bg-white" : "bg-white border border-[#08B89D] text-[#08B89D]"
            }`}
          >
            {step.completed ? <img src={images.CheckCircleIcon} alt="" /> : index + 1}
          </div>

          {/* Step Title */}
          <h3 className="text-sm font-semibold text-gray-800 pl-2">{step.title}</h3>

          {/* Step Content */}
          {step.content && <div className="mt-1 text-gray-600 pl-2">{step.content}</div>}
        </li>
      ))}
    </ul>
  );
};

export default TimelineCommon;
